import { BookOpen, Download } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";

const BASE = "https://connected-center-basra.aglowspark17.chatgpt.site";

const BROCHURES = [
  {
    id: "color-collection",
    num: "01 / THE COLOR COLLECTION",
    cover: `${BASE}/aegis-new/cover-watermarked.webp`,
    view: `${BASE}/aegis-new.html`,
    pdf: `${BASE}/aegis-new/aegis-watermarked.pdf`,
  },
  {
    id: "aegis-intro",
    num: "02 / BLACK & CHAMPAGNE",
    cover: `${BASE}/brochures/aegis/01.webp`,
    view: `${BASE}/catalog.html`,
    pdf: `${BASE}/brochures/aegis/aegis.pdf`,
  },
  {
    id: "more-colors",
    num: "03 / MORE POSSIBILITIES",
    cover: `${BASE}/colors/01.webp`,
    view: `${BASE}/colors.html`,
    pdf: `${BASE}/colors/aegis-colors.pdf`,
  },
];

export default function Brochures() {
  const { t } = useLang();
  return (
    <section id="brochures" data-testid="brochures-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="mb-3 flex items-center gap-3 text-xs font-bold tracking-[0.25em] text-[#E3AF4F]">
            <span className="h-px w-10 bg-[#E3AF4F]" />
            {t.library.eyebrow}
          </p>
          <h2 className="font-heading text-2xl font-bold leading-snug text-[#F5F2EB] sm:text-3xl lg:text-4xl">
            {t.library.heading}
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-[#A8A29E]">
            {t.library.paragraph}
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {BROCHURES.map((b, i) => {
            const text = t.library.items[i];
            return (
              <Reveal key={b.id} delay={i * 0.1} className="h-full">
                <article
                  data-testid={`brochure-card-${b.id}`}
                  className="group flex h-full flex-col overflow-hidden rounded-3xl border border-[#F5F2EB]/10 bg-[#0E0E0E] transition-all duration-500 hover:-translate-y-1 hover:border-[#E3AF4F]/50"
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={b.cover}
                      alt={text.title}
                      loading="lazy"
                      className="h-64 w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <span className="absolute start-5 top-5 rounded-full bg-[#000000]/70 px-3 py-1 text-[10px] font-bold tracking-[0.2em] text-[#E3AF4F] backdrop-blur">
                      {b.num}
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <h3 className="font-heading text-lg font-bold text-[#F5F2EB]">{text.title}</h3>
                    <p className="mt-2 flex-1 text-sm leading-relaxed text-[#A8A29E]">{text.desc}</p>
                    <div className="mt-6 flex gap-3">
                      <a
                        href={b.view}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`brochure-view-${b.id}`}
                        className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-[#E3AF4F] px-5 py-2.5 text-xs font-bold text-[#000000] transition-colors duration-300 hover:bg-[#F5D08C]"
                      >
                        <BookOpen size={14} />
                        {t.library.view}
                      </a>
                      <a
                        href={b.pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`brochure-pdf-${b.id}`}
                        className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-[#F5F2EB]/20 px-5 py-2.5 text-xs font-bold text-[#F5F2EB] transition-all duration-300 hover:border-[#E3AF4F]/60 hover:bg-[#F5F2EB]/5"
                      >
                        <Download size={14} className="text-[#E3AF4F]" />
                        {t.library.download}
                      </a>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
